/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { ContactDetails } from "../../models/contact-details";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadContact$Params {
  organisation_id: string;
  contact_id: number;
}

export function readContact(
  http: HttpClient,
  rootUrl: string,
  params: ReadContact$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ContactDetails>> {
  const rb = new RequestBuilder(rootUrl, readContact.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("contact_id", params.contact_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactDetails>;
    }),
  );
}

readContact.PATH = "/surfdomeinen/organisations/{organisation_id}/contacts/{contact_id}";
